export enum AcademyTrainingsListingTab {
    All = 'all',
    Open = 'open',
    Completed = 'completed'
}
